export default __webpack_public_path__ + "src/assets/cdai.299e6d9b8b659448dbaa2620894ef088.svg";